import emitter from 'garden/src/js/utils/emitter'

import * as cartRepository from 'scripts/api/cart'

import { hideSpinner, showSpinner } from 'reactUtils/Spinner'

export { default as dataLayer } from './data-layer'

export const updateCartQuantity = ({ count }) => emitter.emit('cart:update', { count })

export const cartProductAdded = cart => emitter.emit('cart:products-replace', cart)

export const callApiAndUpdateCart = async () => {
  const {
    data: {
      shippings,
      uniqueProductsCount,
      total,
      subTotal,
      discountTotal
    }
  } = await cartRepository.getCart()

  cartProductAdded({
    shippings,
    uniqueProductsCount,
    total,
    subTotal,
    discountTotal
  })
}

export const handleSpinner = ({ useSpinner = false, action = 'hide' }) => {
  if (!useSpinner) return

  action === 'show'
    ? showSpinner()
    : hideSpinner()
}

export const changeRegionName = ({ ref = {}, regionName = '' }) => {
  if (ref.current && regionName) {
    ref.current.childNodes[1].textContent = regionName
  }
}
